export default __webpack_public_path__ + "static/8-481eb38984fb751cbe88f97c8db3400c.png";